export default "__VITE_ASSET__5ebb554c__"